"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactJsPagination = _interopRequireDefault(require("react-js-pagination"));
var _constants = require("../constants");
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var CustomPagination = function CustomPagination(_ref) {
  var pagesCount = _ref.pagesCount,
    page = _ref.page,
    handlePageChange = _ref.handlePageChange;
  return /*#__PURE__*/_react["default"].createElement(_reactJsPagination["default"], {
    firstPageText: /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      name: "arrow-left",
      fill: _constants.COLORS.CONTRAST_HIGH
    }),
    lastPageText: /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      name: "arrow-right",
      fill: _constants.COLORS.CONTRAST_HIGH
    }),
    innerClass: "d8-c-pagination flex-center",
    activeClass: "active",
    itemClass: "pagination-item",
    hideDisabled: true,
    itemsCountPerPage: 1,
    totalItemsCount: +pagesCount || 1,
    prevPageText: "Prev",
    nextPageText: "Next",
    activePage: +page,
    onChange: handlePageChange
  });
};
CustomPagination.propTypes = {
  pagesCount: _propTypes["default"].number,
  page: _propTypes["default"].number,
  handlePageChange: _propTypes["default"].func
};
CustomPagination.defaultProps = {
  pagesCount: 1
};
var _default = exports["default"] = CustomPagination;